import { useTableActionContext } from '@aibees/elephant/context';
import { SearchType } from '@aibees/elephant/types';
import { ACCORDION_IDS } from '@aibees/shared/store';
import { classnames } from '@aibees/shared/utils';
import { memo, useMemo } from 'react';
import { BulkPanelGuidanceSaved } from '../bulk-panel-guidance-saved';
import { BulkPanelGuidanceTotal } from '../bulk-panel-guidance-total';
import { ContactEnrichmentOptions } from '../contact-enrichment-options';
import * as Styled from './styles';
import * as SX from './sx';
import type { ActionBulkModalAiLookalikeProps as Props } from './types';
import { useSelectedItems } from './use-selected-items';

export const ActionBulkModalAiLookalike = memo(
  ({ className, expandedAccordion, setExpandedAccordion }: Props) => {
    // Use the flow's effective search type (folds in the ActionButton override) so
    // the section title follows the record, not just the page route.
    const { effectiveSearchType } = useTableActionContext();
    const title = useMemo(() => {
      return effectiveSearchType === SearchType.People
        ? 'People Data Enrichment'
        : 'Account Data Enrichment';
    }, [effectiveSearchType]);
    const selectedItems = useSelectedItems();

    return (
      <Styled.Wrapper
        className={classnames('ActionBulkModalAiLookalike', className)}
        sx={SX.root}
        id={ACCORDION_IDS.AI_LOOKALIKE}
        title={title}
        leftIcon={'database-search-outline'}
        expandedAccordion={expandedAccordion}
        setExpandedAccordion={setExpandedAccordion}
        description={selectedItems}
      >
        <ContactEnrichmentOptions />
        <BulkPanelGuidanceTotal />
        <BulkPanelGuidanceSaved />
      </Styled.Wrapper>
    );
  }
);

ActionBulkModalAiLookalike.displayName = 'ActionBulkModalAiLookalike';
